import { API } from "./../../../api/config";

export const getPartnersAPI = (params) => {
    return API.get("/pmbpartner/partners", { params })
              .then((res) => res);
};

export const getDistributorOptionsAPI = (params) => {
    return API.get("/pmbpartner/distributor-options", { params })
              .then((res) => res);
};

export const getCompanyAPI = () => {
    return API.get("/pmbpartner/partners/companies")
              .then((res) => res);
};

export const getPartnerTypesAPI = () => {
    return API.get("/pmbpartner/partners/partner-types")
              .then((res) => res);
};

export const savePartnersAPI = (payload) => {
    return API.post("/pmbpartner/partners", payload)
              .then((res) => res);
};

export const updatePartnersAPI = (param) => {
    return API.put(`/pmbpartner/partners/${param.id}`, param?.payload)
              .then((res) => res);
};